<template>
   <div style="height:100vh;">
    <div class="header pb-6 header-top">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <!-- <h6 class="h2 text-white d-inline-block mb-0">Jourlys</h6> -->
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <!-- <route-bread-crumb></route-bread-crumb> -->
              </nav>
            </div>
            <div class="col-lg-6 col-5 text-right">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--6" style="background-color:#000000">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Reset Password</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->
          <form class="needs-validation" @submit.prevent="handleReset">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Password</label>
                  <div class="has-label">
                    <input
                      class="form-control"
                      name="password"
                      type="password"
                      placeholder="Password"
                      v-model="user.password"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-control-label">Password Confirmation</label>
                  <div class="has-label">
                    <input
                      class="form-control"
                      name="password_confirmation"
                      type="password"
                      placeholder="Password Confirmation"
                      v-model="user.password_confirmation"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Reset Password</base-button
                  >
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
// import { Form } from "vee-validate";
import RequestService from '../../services/request.service';
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";

export default {
  name: "form-elements",
  components: {
    RouteBreadCrumb,
    // Form,
  },
  data() {
    return {
      user:{
	      password: '',
	      password_confirmation : ''
      }
    };
  },
  methods: {
    async handleReset() {
      if(this.user.password == this.user.password_confirmation){
        let response =  await RequestService.post('user-reset-password',this.user);
        if(response.status=='200'){
          this.message = response.data.message;
          this.message = 'Updated Successfully.';
          this.runToast('top-right', 'info');
        }else{
          this.message = 'Something went worng. Please try again.';
          this.runToast('top-right', 'warning');
        }
      }else{
        this.message = "The password confirmation does not match.";
        this.runToast('top-right', 'warning');
      }
      this.user.password = '';
      this.user.password_confirmation = '';
    },
    runToast(pos, type, ownText, ownIcon) {
      const icon = "ni ni-bell-55";
      const content = {
        component: Notification,
        props: {
          ownText: ownText,
          ownIcon: ownIcon,
          icon: icon,
          text: this.message,
          type: type,
        },
      };
      const toast = useToast();
      toast(content, {
        hideProgressBar: true,
        icon: false,
        closeButton: false,
        position: pos,
      });
    },
  },
};
</script>
